// EquipmentService
//
// This service synchronizes the actual room equipment with the database.
// Specifically, it handles the following:
//
// 1. Connecting to the equipment defined for the room.
// 2. Updating the room's online state based on whether the equipment is
//    actually online.
// 3. Updating the other room states (mute, volume, etc.) based on responses
//    from the equipment.
// 4. Watching the room's control events and dispatching them to the
//    appropriate equipment.

'use strict';

var EquipmentServiceImpl = require('./EquipmentServiceImpl');
require('./KayleeService');
require('./RoomService');

angular.module('inara').factory('EquipmentService', EquipmentService);

EquipmentService.$inject = [
    '$timeout',
    'RoomService',
    'KayleeService',
    'AutomationService',
    '$window',
    '$rootScope',
    'LanguageService'
];

function EquipmentService(
    $timeout,
    RoomService,
    KayleeService,
    AutomationService,
    $window,
    $rootScope,
    LanguageService
) {

    var impl = new EquipmentServiceImpl.EquipmentServiceImpl(
        KayleeService,
        RoomService,
        AutomationService,
        LanguageService.getDeviceDriverTranslation,
        function(callback) { $rootScope.$on('DeviceShutdown', callback); },
        function(callback) { $window.addEventListener('beforeunload', callback); },
        process.env.appEnv === 'browser'
    );

    return {
        isRunningUiPreview: impl.isRunningUiPreview,
    };
}

module.exports = EquipmentService;
